import { useSelector } from 'react-redux'
const DoctorDetails = () => {
  const { data: userAppointment } = useSelector(
    (state: any) => state.userAppointment,
  )
  return <></>
}

export default DoctorDetails
